export const PARAM_GOOGLE_CLICK_ID = 'googleClickId';
